import { render, staticRenderFns } from "./AddServiceGroup.vue?vue&type=template&id=3323bac8&"
import script from "./AddServiceGroup.vue?vue&type=script&lang=js&"
export * from "./AddServiceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports